import React, {useEffect} from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "../../../../ui/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../ui/Dialog/DialogActions";
import { getActualPrograms} from "../../../../ManageOOP/Resources/OpMod/MyOPMod/store/actions";
import StateInfoField from "../../pages/StudyRequestView/StudyRequestInfo/StateInfoField";
import {connect} from "react-redux";
import SelectProgramTable from "./SelectProgramTable";
import Progress from "../../../../ui/Progress";

const styles = () => ({
  dialog: {
    width: "620px"
  }
});

const SelectProgramModal = ({requestId,
  requestProgramName,
  requestProgramTargetGroup,
  programId, open, handleClose,
  handleAccept,
  getActualPrograms,
  actualPrograms,
  classes}) => {
  const [program, setProgram] = React.useState(programId);

  useEffect(() => {
    getActualPrograms();
  }, []);

  const onChangeProgram = (value) => {
    setProgram(value);
  };

  const onConfirm = () => {
    handleAccept(requestId, program);
    onClose();
  };

  const onClose = () => {
    handleClose();
  };

  return (
    <div>
      <Dialog onClose={onClose}
              aria-labelledby="customized-dialog-title"
              open={open}
              PaperProps={{
                className: classes.dialog
              }}>
        <DialogTitle onClose={onClose}>Выбор программы обучения</DialogTitle>
        <DialogContent>
          <StateInfoField field="Заявленная программа" value={requestProgramName || 'не указана'}/>
          <StateInfoField field="Целевая аудитория" value={requestProgramTargetGroup || 'не указана'}/>
          <br/>
          {actualPrograms && <SelectProgramTable
            selectedPlan={program}
            onProgramSelected={programId => onChangeProgram(programId)}
            programList={actualPrograms}
            />}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            onClick={() => onConfirm()}
            color="green"
          >
            Подтвердить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )};

const mapStateToProps = state => ({
  actualPrograms: state.programs.actualPrograms
});

const mapDispatchToProps = dispatch => ({
  getActualPrograms: () => dispatch(getActualPrograms())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(SelectProgramModal));
